import { call, put, takeLatest, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import * as PropertyActions from '../actions/propertyAction';
import * as PropertyService from './../services/propertyService';
import Property from '../models/Property';
import { PATHS } from '../constants/Define';
import history from '../helpers/history';

function* getListProperty() {
    yield takeLatest(Types.PROPERTY_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(PropertyService.getProperties, params);
        yield put(PropertyActions.dataPropertySuccess(result));
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

function* getAllProperty() {
    yield takeLatest(Types.PROPERTY_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PropertyService.getAllProperties);
        yield put(PropertyActions.dataAllPropertySuccess(result));
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

function* getAllTourProperty() {
    yield takeLatest(Types.PROPERTY_TOUR_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PropertyService.getAllTourProperties);
        yield put(PropertyActions.setAllTourPropertySuccess(result));
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

function* getPropertyDetail() {
    yield takeLatest(Types.PROPERTY_GET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PropertyService.getPropertyDetail, action.params.id);
        yield put(PropertyActions.getUpdatePropertySuccess(result));
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

function* createProperty() {
    yield takeLatest(Types.PROPERTY_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const property = (action.params.data)
        yield call(PropertyService.createProperty, property);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), property.name);
        history.push(PATHS.PROPERTY.LIST.path);
        history.go();
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

function* updateProperty() {
    yield takeLatest(Types.PROPERTY_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const property = (action.params.data);
        yield call(PropertyService.updateProperty, property);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), property.name);
        yield put({ type: Types.PROPERTY_UPDATE_SUCCESS });
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

function* deleteProperty() {
    yield takeLatest(Types.PROPERTY_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PropertyService.deleteProperty, action.params.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
        yield put({ type: Types.PROPERTY_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

// TRANSLATE
function* createPropertyTranslate() {
    yield takeLatest(Types.PROPERTY_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PropertyService.createPropertyTranslate, action.property);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.property.translate.languageName);
        yield put({ type: Types.PROPERTY_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.PROPERTY_GET_UPDATE_ACTION, params: { id: action.property.id } });
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

function* updatePropertyTranslate() {
    yield takeLatest(Types.PROPERTY_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PropertyService.updatePropertyTranslate, action.property);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.property.translate.languageName);
        yield put({ type: Types.PROPERTY_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.PROPERTY_GET_UPDATE_ACTION, params: { id: action.property.id } });
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

function* deletePropertyTranslate() {
    yield takeLatest(Types.PROPERTY_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PropertyService.deletePropertyTranslate, action.property.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.property.translate.languageName);
        yield put({ type: Types.PROPERTY_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.PROPERTY_GET_UPDATE_ACTION, params: { id: action.refreshParams.id } });
    }, errorHandleProperty(Types.PROPERTY_FAIL)))
}

function errorHandleProperty(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'property');
}

export function* propertySaga() {
    yield all([
        fork(getListProperty),
        fork(createProperty),
        fork(deleteProperty),
        fork(getPropertyDetail),
        fork(updateProperty),
        fork(getAllProperty),
        fork(getAllTourProperty),
        fork(createPropertyTranslate),
        fork(updatePropertyTranslate),
        fork(deletePropertyTranslate),
    ])
}
